import { signOut } from 'firebase/auth';
import { useNavigate } from 'react-router-dom';
import { auth } from '../../firebase';

interface Props {
  onClose: () => void;
}

const LogoutConfirmationPopUp = ({ onClose }: Props) => {
  const navigate = useNavigate();

  const handleConfirm = async () => {
    await signOut(auth);
    navigate('/login');
  };

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg shadow-lg p-6 w-80 text-center">
        <p className="mb-4">Voulez-vous vraiment vous déconnecter ?</p>
        <div className="flex justify-between mt-6">
          <button
            onClick={onClose}
            className="px-4 py-2 bg-gray-200 rounded hover:bg-gray-300"
          >
            Annuler
          </button>
          <button
            onClick={handleConfirm}
            className="px-4 py-2 bg-red-600 text-white rounded hover:bg-red-700"
          >
            Se déconnecter
          </button>
        </div>
      </div>
    </div>
  );
};

export default LogoutConfirmationPopUp;
